import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverRatingList extends Layout {
    layoutheaderDriverRating: LayoutHeader;
    sourceDriverRating: DataSource;
    tableDriverRating: Table;
}
